var _rect, _rect2, _path, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeAppstore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 54,
    viewBox: "0 0 180 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 54,
    rx: 10,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 52,
    rx: 9,
    x: 1,
    y: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13.8c.8-1 1.3-2.4 1.2-3.8-1.2.1-2.6.8-3.5 1.8-.8.9-1.4 2.3-1.2 3.6 1.3.1 2.7-.6 3.5-1.6z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7 15.7c-1.9-.1-3.6 1.1-4.5 1.1-.9 0-2.3-1-3.8-1-2 0-3.8 1.2-4.8 3-2.1 3.6-.5 8.9 1.5 11.8 1 1.4 2.1 3 3.6 3 1.5-.1 2-.9 3.8-.9s2.3.9 3.8.9c1.5 0 2.5-1.4 3.5-2.8.4-.6.8-1.2 1-1.8-2.6-1-4.3-3.6-4.3-6.4 0-2.5 1.3-4.7 3.3-5.9-.9-1.5-2.3-2-3.1-2z",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fontFamily: "-apple-system, Helvetica Neue, sans-serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.85
  }, "Download on the")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 38,
    fontFamily: "-apple-system, Helvetica Neue, sans-serif",
    fontSize: 18,
    fontWeight: 600,
    fill: "#fff"
  }, "App Store")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeAppstore);
export default __webpack_public_path__ + "static/media/badge-appstore.6c6e037f6bc8b11a43daac296c694c9d.svg";
export { ForwardRef as ReactComponent };